<template>
    <div class="sub-body">
        <div class="nav-bg"></div>
        <div class="con">
            <div class="row">
                <div class="col-md-3 sub-navi">
                    <div id="navi" class="navi on" @mousedown="moveStart" @mouseup="moveEnd">
                        <label class="select-clients">Select Clients</label>
                        <div class="link-wrapper" id="linkWrapper">
                            <div id="scroll-bar" class="scroll-bar"></div>
                            <div id="links-outline" class="links-outline">
                                <div class="links" :class="{ 'active': activeMenu == idx }" v-for="(brand, idx) in brands" :key="idx" @click="goto(idx)">{{ brand }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 project-outline" id="project-outline">
                    <div id="project-box" class="project-box smth-scroll" :class="{ 'effect': effect }">
                        <div class="project" id="project-0" data-name="APA Beauty" data-type="0">
                            <router-link to="/client/apa_beauty">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_apa/apa_thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-1" data-name="Bobbi Brown" data-type="1">
                            <router-link to="/client/bobbi_brown">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_bobbibrown/bobbibrown_thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-2" data-name="Coty" data-type="1">
                            <router-link to="/client/coty">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_coty/Thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-3" data-name="Dior Beauty" data-type="1">
                            <router-link to="/client/dior_beauty">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/portfolio/Dior+Beauty/DIOR_Spotlight_Fall23_LIVE.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-4" data-name="Donald+Eunsun" data-type="3">
                            <router-link to="/client/donald+eunsun">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_donaldeunsun/thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-5" data-name="Estée Lauder" data-type="2">
                            <router-link to="/client/estée_lauder">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_esteelauder/esteelauder_thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-6" data-name="Evercell" data-type="4">
                            <router-link to="/client/evercell">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/portfolio/Evercell/Evercell_1.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-7" data-name="Flirt" data-type="4">
                            <router-link to="/client/flirt">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_flirt/Thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-8" data-name="Garth Fisher" data-type="5">
                            <router-link to="/client/garth_fisher">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_fisher/Thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-9" data-name="KVD Beauty" data-type="5">
                            <router-link to="/client/kvd_beauty">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/kvd_1.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-10" data-name="La mer" data-type="6">
                            <router-link to="/client/la_mer">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_lamer/3_Capture-One-Session2528.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-11" data-name="Laura Mercier" data-type="7">
                            <router-link to="/client/laura_mercier">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_lauramercier/thumbnails.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-12" data-name="Rodin" data-type="8">
                            <router-link to="/client/rodin">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_rodin/thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>

                        <div class="project" id="project-13" data-name="Saturday Skin" data-type="9">
                            <router-link to="/client/saturday_skin">
                                <div class="work-image">
                                    <div class="info">
                                        <div class="txt">View Work</div>
                                    </div>
                                    <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/work_saturdayskin/thumbnail.jpg" />
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
var isScrolling


export default {
    components: {
	},
    data() {
        return {
            brands          : [
                'APA',
                'Bobbi Brown',
                'Coty',
                'Dior Beauty',
                'Donald+Eunsun', 
                'Estée Lauder',
                'Evercell',
                'Flirt',
                'Garth Fisher',
                'KVD Beauty',
                'La Mer',
                'Laura Mercier',
                'Rodin',
                'Saturday Skin',
            ],
            projectOffset   : [],
            navMouse        : false,
            x               : 0,
            activeMenu      : 9999,
            effect          : false,
            moving          : false,
            clickMoving     : false,
            clickAfter      : false,
            supportsTouch   : false,
        }
    },
    created() {
    },
    mounted() {
        setTimeout(() => {
            this.resize() 
            this.afterload()
        }, 500)

        this.init()
        
        const winW      = document.body.clientWidth
        const header    = document.getElementById('header')

        header.classList.remove('bg-active')

        window.addEventListener("scroll",           this.smoothing) 
        window.addEventListener("resize",           this.resize)
        document.getElementById('linkWrapper').addEventListener('scroll', this.touchMoving, false)

        var wwd = document.querySelector('.whatwedo')
        var wwa = document.querySelector('.whoweare')
        var ctu = document.querySelector('.contactus')

        wwa.style.textDecoration = "none"
        ctu.style.textDecoration = "none"
        wwd.style.textDecoration = "underline"

        this.supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints
        if(!this.supportsTouch) this.effect = true

        setTimeout(() => {
            this.clickAfter = true
        }, 2000)

    },
    beforeDestroy() {
        const winW      = document.body.clientWidth

        window.removeEventListener("scroll",        this.smoothing)  
        window.removeEventListener('resize',        this.resize)
        document.getElementById('linkWrapper').removeEventListener('scroll', this.touchMoving, false)
    },

    methods: {
        init() {
            let winW = document.body.clientWidth

            if(winW >= 768) {
                const projectBoxTop     = document.getElementById('project-box')
                var i = 0
                var per = 100

                if(!this.supportsTouch) {
                    projectBoxTop.style.transform = 'translate(-50%, 100%)'
                }else{
                    projectBoxTop.style.transform = 'translateY(100%)'
                }
                projectBoxTop.style.opacity = 1
                
                var int = setInterval(() => {
                    i += .5
                    per = this.easing((100 - i) / 100) * 100

                    if(!this.supportsTouch) {
                        projectBoxTop.style.transform = 'translate(-50, ' + per + '%)'
                    }else{
                        projectBoxTop.style.transform = 'translateY(' + per + '%)'
                    }

                    if (i == 100) clearInterval(int)
                }, 8)

                setTimeout(() => {
                    var winH = window.innerHeight
                    var conH = document.getElementById('project-outline').offsetHeight + 58
                    var linkH = document.getElementById('links-outline').offsetHeight
                    var sb = document.getElementById('scroll-bar')
                    var lineH = winH * linkH / conH

                    sb.style.height = lineH + 'px'
                }, 1000 )
                
            }
        },
        moveStart(e) {
            this.navMouse   = true
            this.x          = document.getElementById("navi").scrollLeft + e.clientX
        },
        moveEnd(e) {
            this.navMouse = false
        },
        getOffsetY() {
            const projects          = document.querySelectorAll('.project')
            const projectBoxTop     = document.getElementById('project-box').offsetTop
            this.projectOffset      = []
            
            projects.forEach((elem, idx) => {
                this.projectOffset.push( projectBoxTop + elem.offsetTop)
            })
        },
        smoothing() {
            const winW = document.body.clientWidth
            var smoothScrollFeature = 'scrollBehavior' in document.documentElement.style

            if(winW >= 768) {
                var speed   = 1
                var target  = document.querySelector('.smth-scroll')
                if(!target) return
                if(!this.supportsTouch) {
                    target.style.transform = `translate(-50%, ${-Math.floor(window.scrollY)}px)`
                }

                // Clear our timeout throughout the scroll
                window.clearTimeout( isScrolling )
                isScrolling = setTimeout(() => {
                    if(!this.clickMoving) this.changeOnScroll()
                }, 66)

                // move nav line
                var winH = window.innerHeight
                var conH = document.getElementById('project-outline').offsetHeight + 58
                var linkH = document.getElementById('links-outline').offsetHeight
                var sb = document.getElementById('scroll-bar')
                var my = Math.round((linkH - sb.offsetHeight) * (window.scrollY / (conH - winH)))
                sb.style.transform = 'translateY(' + my + 'px)'

                
                

            }else{
                // Clear our timeout throughout the scroll
                this.changeMobileScroll()
            }
        },
        touchMoving() {
            var elemW = document.getElementById('links-outline').offsetWidth
            var scrollX = document.getElementById('linkWrapper').scrollLeft
            var scrollBar = document.getElementById('scroll-bar').offsetWidth
            var per = Math.round( ( 100 - ( elemW - scrollX - 25 + 50 - window.outerWidth ) / ( elemW - window.outerWidth + 25 ) * 100 ) )
            document.getElementById('scroll-bar').style.left = per + '%'
            document.getElementById('scroll-bar').style.marginLeft = ((scrollBar + 8) * per * -0.01) + 4 + 'px'

        },
        goto(idx) {
            if(!this.clickAfter) return
            const elem      = document.querySelector('#project-' + idx)
            const navi      = document.getElementById("navi")
            var dataName    = elem.getAttribute("data-name")
            var dataType    = elem.getAttribute("data-type")
            this.activeMenu = idx

            this.clickMoving = true
            setTimeout(() => { this.clickMoving = false }, 1000)

            navi.classList.remove('on')

            for(var brand in this.brands){
                
                if(brand == dataType) {
                    window.scrollTo({
                        left: 0,
                        top: elem.offsetTop,
                        behavior: 'smooth'
                    })
                }
            }  
        },
        changeOnScroll() {
            var tar = document.querySelectorAll('.links'),
                top  = window.pageYOffset || document.documentElement.scrollTop,
                activeIdx = 0,
                loop = true

            const winW          = document.body.clientWidth
            if(winW < 1600) {
                top += window.innerHeight/2
            }else{
                top += 600
            }

            this.projectOffset.forEach((pos, idx) => {   
                if(pos > top && loop) {
                    loop = false;
                    (idx == 0) ? activeIdx = 0 : activeIdx = idx - 1
                    this.activeMenu = activeIdx;
                }else if(this.projectOffset[this.projectOffset.length - 1] < top){
                    loop = false;
                    activeIdx = this.projectOffset.length - 1
                    this.activeMenu = activeIdx;
                }
            })
        },
        changeMobileScroll() {
            const linkWrapper = document.getElementById('linkWrapper')
            const linksOutline = document.getElementById('links-outline')

            var active = 0
            for(var idx in this.brands) {
                var elem = document.querySelector('#project-' + idx)
                if(window.scrollY >= elem.offsetTop - 150) active = idx
            }

            if( window.scrollY > 280 ) var x = ( window.scrollY - 280 ) / ( document.getElementById('project-outline').offsetHeight + 58 - 280 ) 

            var left = document.querySelectorAll('#linkWrapper .links')[active].offsetLeft
            var next = document.querySelectorAll('#linkWrapper .links')[Number(active) + 1].offsetLeft
            

            if(window.scrollY > ( document.getElementById('project-outline').offsetHeight - window.innerHeight - 158 )) {
                this.activeMenu = this.brands.length - 1
            }else{
                this.activeMenu = active
            }

            var to = linksOutline.offsetWidth * x
            linkWrapper.scroll(to, 0)

        },
        afterload() {
            document.body.className = ''
            this.smoothing()
        },
        resize() {
            this.getOffsetY()
            const target        = document.getElementById('project-box')
            const outline       = document.getElementById('project-outline')
            const winW          = document.body.clientWidth
            const lastProject   = document.querySelector('.project:last-child').offsetHeight

            if(winW < 768) {
                outline.style.height = ''
                target.style.transform = 'none'
            }else if(winW < 1199.98) {
                outline.style.height = target.offsetHeight + (window.innerHeight/2) - (lastProject / 2) + 29 + 'px'
            }else {
                outline.style.height = target.offsetHeight + (window.innerHeight/2) - (lastProject / 2) + 29 + 'px'
            }
        },
        easing(progress) {
            return progress < 0.5 ? 4 * progress * progress * progress : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1
        },
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/pages/whatwedo.scss';
</style>


// WEBPACK FOOTER //
// src/pages/whatwedo.vue